import { render } from "./ImageLightbox.vue?vue&type=template&id=e9d6c1ae&scoped=true"
import script from "./ImageLightbox.vue?vue&type=script&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&lang=js"

import "./ImageLightbox.vue?vue&type=style&index=0&id=e9d6c1ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9d6c1ae"]])

export default __exports__